import { render, staticRenderFns } from "./gisLegend.vue?vue&type=template&id=55182a5e&scoped=true"
import script from "./gisLegend.vue?vue&type=script&lang=js"
export * from "./gisLegend.vue?vue&type=script&lang=js"
import style0 from "./gisLegend.vue?vue&type=style&index=0&id=55182a5e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55182a5e",
  null
  
)

export default component.exports